let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6d23n")).then(() => parcelRequire('f9TVv'));